import React, { useState, useEffect } from "react";
import { getFreelancerReviews } from "../../../../services/reviewsService";
import { useNavigate } from "react-router-dom";
import { getImage } from "../../../../utils/cloudinarySizing";

const MyReviews = (freelancerId) => {
    const [reviews, setReviews] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await getFreelancerReviews(freelancerId.freelancerId); // Fetch review
                setReviews(data.reviews); // Update state with reviews
            } catch (err) {
                console.log(err)
            }
        };
        fetchReviews();
    }, [freelancerId]);

    if (reviews === null) return null;  // ✅ Avoid flashing "0 Reviews"

    return (
        <div className="reviews-container">
            <p
                style={{
                    color: "var(--text)",
                    textAlign: reviews.length === 0 ? "center" : "right",
                }}
                className="own-reviews"
            >
                {reviews.length === 0
                    ? "No reviews"
                    : `${reviews.length} ${reviews.length === 1 ? "Review" : "Reviews"}`}
            </p>
            <div className="review-container">
                {reviews.map((review, index) => (
                    <div key={index} className="review-box">
                        <div className="review-content">
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <i
                                        key={star}
                                        className={`fa-star ${review.rating >= star ? "fas highlighted" : "fas"}`}
                                    ></i>
                                ))}
                            </div>
                            <p className="review-text">"{review.comment}"</p>
                            <div className="review-user-info">
                                {/* Date on the far left */}
                                <p className="review-date">
                                    {new Date(review.created_at).toLocaleString('en-US', {
                                        month: 'short',   // Short month name (Jan, Feb, etc.)
                                        day: 'numeric',   // Day of the month (28)
                                        year: 'numeric',  // Year (2025)
                                        hour: '2-digit',  // Hour in 12-hour format (10)
                                        minute: '2-digit',// Minute (50)
                                        hour12: true      // Use 12-hour format (with AM/PM)
                                    })}
                                </p>

                                {/* Profile image and name on the far right */}
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <img
                                        onClick={() => navigate(`/profile/${review.user.id}`)}
                                        src={getImage(review.user?.profile_image, "avatar_xsm") || '/servspace-default-40x40.png'}
                                        alt={review.user?.name || 'User'}
                                        className="review-user-image"
                                        onError={(e) => {
                                            e.currentTarget.onerror = null; // prevents infinite loop if fallback also fails
                                            e.currentTarget.src = '/servspace-default-40x40.png';
                                        }}
                                    />
                                    <p
                                        className="customer-name"
                                        onClick={() => navigate(`/profile/${review.user.id}`)}
                                    >
                                        {review.user.name}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
};

export default MyReviews;